import { VehicleService } from "../../../service/vehicle-service";

// eslint-disable-next-line no-unused-vars
const saveCustomerReview = (payload, secureToken) => (dispatch) => {
    return new Promise((resolve, reject) => {
        VehicleService.saveCustomerReview(payload, secureToken)
            .then(response => {
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export {
    saveCustomerReview
};
